import React, { Fragment, useState, useEffect } from "react";
import PageTitle from "../container/layouts/PageTitle";
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  Dropdown,
  ProgressBar,
  Button,
  Modal,
  Form
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import axios from "axios";
import { Progress } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getInstance } from '../config/token';
import Spinner from 'react-bootstrap/Spinner'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import BootstrapTable from "react-bootstrap-table-next";
// import ToolkitProvider from "react-bootstrap-table2-toolkit";
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone
} from 'react-bootstrap-table2-paginator';
import dateFormat from "dateformat";
// import { Form, Dropdown } from "react-bootstrap";

const prefix = process.env.REACT_APP_API_URL

const defaultPageSize = 100
const defaultSortOrder = 'desc'
const defaultSortKey = 'id'

const sizePerPageList = [ {
  text: '10', value: 10
}, {
  text: '25', value: 25
}, {
  text: '50', value: 50
}, {
  text: '75', value: 75
}, {
  text: '100', value: 100
} ]

/// imge

const TicketList = () => {
  const [ show, setShow ] = useState(false);
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [message, setmessage] = useState("");
  const [order_id, setOrderId] = useState("");
  const [file, setFile] = useState("");
  const [loaded, setLoader] = useState(0);
  const [fileName, setFileName] = useState([]);
  const [cameraModal, setCameraModal] = useState(false);
  const [newEvent, setNewEvent] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [ticketList, setTicketList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileLabel, setFileLabel] = useState("");
  const [fileData, setFileData] = useState("");
  const [filePath, setFilePath] = useState([]);
  const[type, setType] = useState(0)
  const[userType, setUserType] = useState(0)
  const[status, setStatus] = useState("")
  const[statusFilter, setStatusFilter] = useState("0")
  const [loadingList, setLoadingList] = useState(false);
  const[searchTicket, setSearchTicket] = useState("")
  const[openCount, setOpenCount] = useState(0)
  const[pendingCount, setPendingCount] = useState(0)
  const[closedCount, setClosedCount] = useState(0)
  const[spamCount, setSpamCount] = useState(0)
  const[columneDisplayField, setColumneDisplayField] = useState("")
  const[columneDisplayValue, setColumneDisplayValue] = useState(false)
  const[currentPage, setCurrentPage] = useState(1)
  const[pageSize, setPageSize] = useState(defaultPageSize)
  const[totalCount, setTotalCount]=useState(0)
  const[sortKey, setSortKey] = useState(defaultSortKey)
  const[sortType, setSortType]=useState(defaultSortOrder)
  const[randomValue, setRandomValue] = useState(0)
  const[selected, setSelected] = useState([])
  const[modalStatus, setModalStatus] = useState(false)
  const[statusTicktId, setStatusTicktId] = useState("")
  const[statusTicktType, setStatusTicktType] = useState("")
  const[userTypeFilter, setUserTypeFilter] = useState("0")
  const[rentCount, setRentCount] = useState(0)
  const[supportCount, setSupportCount] = useState(0)


  useEffect( () => {
    getTicketList()
    
 }, [statusFilter, searchTicket, currentPage, pageSize, sortType, sortKey, userTypeFilter]);

 useEffect( () => {
  getTicketCount()
}, []);

const columns = [
  {
    dataField: "ticket_id",
    text: "#",
    // hidden : localStorage.getItem("id")
    modify : false,
    sort: true,
  },
  {
    dataField: "ticket_column_title",
    text: "Title",
    // hidden : localStorage.getItem("ticket_column_title")
    hidden : localStorage.getItem("ticket_column_title") == null || localStorage.getItem("ticket_column_title") == 'null' ? false : JSON.parse(localStorage.getItem("ticket_column_title")),
    modify : true,
    sort: true
    // dataSort
    // headerSortingStyle
  },
  {
    dataField: "ticket_column_type",
    text: "Type",
    hidden : localStorage.getItem("ticket_column_type") == null || localStorage.getItem("ticket_column_type") == 'null' ? true : JSON.parse(localStorage.getItem("ticket_column_type")),
    modify : true,
    // sort: true
  },
  {
    dataField: "ticket_column_owner",
    text: "Ticket Owner",
    hidden : localStorage.getItem("ticket_column_owner") == null || localStorage.getItem("ticket_column_owner") == 'null' ? true : JSON.parse(localStorage.getItem("ticket_column_owner")),
    modify : true,
    // sort: true
  },
  {
    dataField: "ticket_column_order",
    text: "Order Id",
    hidden : localStorage.getItem("ticket_column_order") == null || localStorage.getItem("ticket_column_order") == 'null' ? true : JSON.parse(localStorage.getItem("ticket_column_order")),
    modify : true,
    // sort: true
  },
  {
    dataField: "ticket_column_created",
    text: "Created Date",
    hidden : localStorage.getItem("ticket_column_created") == null || localStorage.getItem("ticket_column_created") == 'null' ? true : JSON.parse(localStorage.getItem("ticket_column_created")),
    modify : true,
    // sort: true
  },
  // {
  //   dataField: "ticket_column_status",
  //   text: "Status",
  //   // hidden : localStorage.getItem("ticket_column_status")
  //   hidden : localStorage.getItem("ticket_column_status") == null || localStorage.getItem("ticket_column_status") == 'null' ? false : JSON.parse(localStorage.getItem("ticket_column_status")),
  //   modify : true,
  //   // sort: true
  // },
]

// if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) {
//   columns.push(
//     {
//       dataField: "ticket_column_action",
//       text: "Action",
//       // hidden : localStorage.getItem("ticket_column_action")
//       hidden : localStorage.getItem("ticket_column_action") == null || localStorage.getItem("ticket_column_action") == 'null' ? false : JSON.parse(localStorage.getItem("ticket_column_action")),
//     modify : true,
//     // sort: true
//     }
//   )
// }


// const mapTicketData = () => {
  var ticketData = []
 ticketList.map(function (item, i) {
    return (
      ticketData.push({
        ticket_id : <div>
            <div>
              <Link to={`/ticket/${item.id}`}>
                <strong style={{color : item.is_email_wrong ? "red" : "black"}}>{"BGTKT" + item.id}</strong>
              </Link>
            </div>
          <div>
        <Badge variant="success light" style = {{cursor : "pointer"}} className={item.status == 0 ?"status-open" : item.status == 1 ? "status-closed" : "status-pending"}>
          {item.status == 0
            ? 
            <span onClick={() => openStatusModal(item.id, 0)}>
                Open
              </span>
            : item.status == 1? 
            <span onClick={() => openStatusModal(item.id, 1)}>
              Completed
            </span>
            : item.status == 2 ?
            <span onClick={() => openStatusModal(item.id, 2)}>
            Pending
            </span>
            : item.status == 3 ? <span onClick={() => openStatusModal(item.id, 3)}>
              Spam
              </span> : ""
          }
        </Badge>
        </div>
        </div>,
      ticket_column_title : <Link style={{color : "#111"}}to={`/ticket/${item.id}`}>{item.title}</Link>,
      ticket_column_type : `${item.type == 0
        ? "Tech Support"
        : item.type == 1
        ? "Order Support"
        : item.type == 2
        ? "Order Inquiry"
        : item.type == 3
        ? "Other"
        : "-"}`,
        ticket_column_owner : `${item.user
          ? item.user.first_name && item.user.last_name
            ? item.user.first_name +
              " " +
              item.user.last_name
            : item.user.first_name
            ? item.user.first_name
            : item.user.last_name
            ? item.user.last_name
            : "-"
          : "-"}`,

          ticket_column_order : `${item.order_id ? "BGUSA" + item.order_id : "-"}`,
          ticket_column_created : `${new Date(item.createdAt).toLocaleString('en-US', { timeZone: 'America/New_York' })}`,
          ticket_column_status : <Badge variant="success light" className={item.status == 0 ?"status-open" : item.status == 1 ? "status-closed" : item.status == 2 ? "status-pending" : "status-spam"}>
          {item.status == 0
            ? "Open"
            : item.status == 1
            ? "Completed"
            : item.status == 2 ? "Pending" 
            : item.status == 3 ? "Spam" : ""}
        </Badge>,
        id : item.id,
      //   ticket_column_action : <select
      //   className="form-control form-border-color"
      //   style={{ width: "fit-content" }}
      //   name="type"
      //   id="type"
      //   defaultValue={item.status}
      //   onChange={(e) => changeStatus(e, item.id)}
      // >
      //   <option value="0">Open</option>
      //   <option value="1">Closed</option>
      //   <option value="2">Pending</option>
      // </select>,
      is_new_reply : localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? item.is_new_reply : item.is_new_reply_owner
      })
    )
  })
// }

const openStatusModal = (ticketId, statusType) => {
  if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
    setModalStatus(true)
    setStatusTicktId(ticketId)
    setStatusTicktType(statusType)
  }
}

const onStatusChange = (e, ticketIds) => {
  setStatus(e.target.value)
}

const returnList = () => {
  // console.log("call", col)
  // return col
  //   .map((column) => ({
  //     ...column,
  //     toggle: toggles[column.dataField],
  //   }))
    return columns.map((column) => (
      column.modify?
      <Form.Check
        type="checkbox"
        key={column.dataField}
        inline
        label={column.text}
        id={column.dataField}
        //aria-pressed={(column.toggle) ? "true" : "false"}
        checked={column.hidden}
        aria-checked={column.hidden ? "true" : "false"}
        // onChange = {() => onColumnToggle(column.dataField)}
        onClick={() => showHideColumn(column.dataField, column.hidden)}
        // onClick={() => onColumnToggle(column.dataField)}
      /> : ""
    ));
};

const showHideColumn = (field,value) =>{
  if(field != 'id'){
    let fieldValue = (JSON.parse(localStorage.getItem(field)) == null || JSON.parse(localStorage.getItem(field)) == 'null' ? value : JSON.parse(localStorage.getItem(field)))
    localStorage.setItem(field, !fieldValue)
    setColumneDisplayValue(!columneDisplayValue)
    setColumneDisplayField(field)
    setRandomValue(Math.floor(Math.random() * 1000)+1)
  }
}

 const getTicketCount = () => {
  let config = getInstance('GET', `/api/get_ticket_list_count`, {});
  axios(config)
  .then((res) => {
    if(res.data && res.data.statusCount && res.data.statusCount.length){
      for(let i=0; i < res.data.statusCount.length; i++){
        if(!res.data.statusCount[i].status || res.data.statusCount[i].status == 'false'){
          setOpenCount(res.data.statusCount[i].ticketCount)
        } 
        if((res.data.statusCount[i].status || res.data.statusCount[i].status == 'true') && (res.data.statusCount[i].status != 2 && res.data.statusCount[i].status != '2' && res.data.statusCount[i].status != 3 && res.data.statusCount[i].status != '3')){
          setClosedCount(res.data.statusCount[i].ticketCount)
        } 
        if(res.data.statusCount[i].status == 2 || res.data.statusCount[i].status == '2'){
          setPendingCount(res.data.statusCount[i].ticketCount)
        }
        if(res.data.statusCount[i].status == 3 || res.data.statusCount[i].status == '3'){
          setSpamCount(res.data.statusCount[i].ticketCount)
        }
      }
    }
    if(res.data && res.data.typeCount && res.data.typeCount.length){
      for(let i=0; i < res.data.typeCount.length; i++){
        if(res.data.typeCount[i].user_type == 3 || res.data.typeCount[i].user_type == '3'){
          setRentCount(res.data.typeCount[i].ticketTypeCount)
        } 
        if(res.data.typeCount[i].user_type == 4 || res.data.typeCount[i].user_type == '4'){
          setSupportCount(res.data.typeCount[i].ticketTypeCount)
        } 
       
      }
    }
  })
  .catch((err) => {
    console.log("Error", err)
  })
}


 const getTicketList = () => {
   setLoadingList(true)
   let reqObj = {
     status : statusFilter,
     search : searchTicket,
     page : currentPage,
     size : pageSize,
     sort : sortType,
     key : sortKey,
     user : userTypeFilter
   }
   let config = getInstance('POST', `/api/get_ticket_list`, reqObj);
  axios(config)
  .then((res) => {
    setTotalCount(res.data.count ? res.data.count : 0)
    setTicketList(res.data.rows ? res.data.rows : [])
    setLoadingList(false)
  })
  .catch((err) => {
    setLoadingList(false)
  })
 }

  const createTicket = () => {
    // setErrMsg("")
    let errFlag = false;
    if (title == "") {
      errFlag = true;
      toast.error("Title is required.", {
        position: "top-right",
      });
      setErrMsg("Title is required.");
    } else if (title.length > 255) {
      errFlag = true;
      toast.error("Title can not be more than 255 characters.", {
        position: "top-right",
      });
      setErrMsg("Title can not be more than 255 characters.");
    } else if (message == "") {
      errFlag = true;
      toast.error("Message is required.", {
        position: "top-right",
      });
      setErrMsg("Message is required.");
    } else if (message.length > 5000) {
      errFlag = true;
      toast.error("Message can not be more than 5000 characters.", {
        position: "top-right",
      });
      setErrMsg("Message can not be more than 5000 characters.");
    } else if (order_id && order_id.length > 11) {
      errFlag = true;
      toast.error("Order id can not be more than 11 characters.", {
        position: "top-right",
      });
      setErrMsg("Order id can not be more than 11 characters.");
    }

    if (!errFlag) {
      let requestObj = {
        title: title,
        message: message,
        order_id: order_id,
        type: type,
        // fileData : fileData,
        file : filePath,
        // userType : userType
        // file: data,
      };

      if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
        if (email == "") {
          toast.error("Email is required.", {
            position: "top-right",
          });
          return
        } else{
          // if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            requestObj.email = email
          // } else{
          //   toast.error("You have entered an invalid email address!", {
          //     position: "top-right",
          //   });
          //   return
          // }
        }
        if (userType == 0) {
          toast.error("Please select user.", {
            position: "top-right",
          });
          return
        } 
        requestObj.userType = userType
      }
      let config = getInstance('POST', `/api/create_ticket`, requestObj);
      axios(config)
        // .post(prefix + "/api/create_ticket", requestObj)
        .then((res) => {
          setNewEvent(false);
          setFileName([]);
          setTitle("");
          setmessage("");
          setOrderId("");
          setFile("");
          setFilePath([])
          getTicketList()
          getTicketCount()
          setSelected([])

          toast.success("Ticket Successfully Created", {
            position: "top-right",
          });
        })
        .catch((err) => {
          let msg = "Something went wrong!"
          // setLoading(false)
          if(err.response && err.response.data && err.response.data.message){
            msg = err.response.data.message
          }
          toast.error(msg, {
            position: "top-right",
          });
        });
    }
    // else {
    //   toast.error(errMsg, {
    //     position: "top-right",
    //   });
    // }
  };


  const maxSelectFile=(event)=>{
    let files = event.target.files // create file object
        if (files.length > 3) { 
          //  const msg = 'Only 3 images can be uploaded at a time'
           event.target.value = null // discard selected file
           toast.error("Only 2 files can be uploaded at a time.", {
            position: "top-right",
          });
          return false;
 
      }
    return true;
 
 }

 const checkFileSize=(event)=>{
  let files = event.target.files
  let size = 5000000
  let err = ""; 
  for(var x = 0; x<files.length; x++) {
  if (files[x].size > size) {
   err += files[x].type+' is too large, please pick a smaller file\n';
 }
};
if (err !== '') {
  event.target.value = null
  toast.error(err, {
    position: "top-right",
  });
  return false
}

return true;

}

  const onFileChange = (e) => {
    // this.setState({ file: e.target.files[0] },() => {
      var mulFiles = e.target.files
      if(maxSelectFile(e) && checkFileSize(e)){ 
        setLoading(true)
        setFile(mulFiles);
        const data = new FormData();
        for(var x = 0; x < mulFiles.length; x++) {
          data.append('file', mulFiles[x])
      }
        // data.append("file", e.target.files[0]);
        let config = getInstance('POST', `/api/upload`, data);
        // axios(config,
        //   onUploadProgress: (ProgressEvent) => {
        //     console.log("ProgressEvent", ProgressEvent)
        //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
        //   },
        // )
        axios.post(config.url, config.data,  {
            headers: config.headers,
            onUploadProgress: (ProgressEvent) => {
              setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
            },
          })
    
          .then((res) => {
            // then print response status
            setLoader(0);
            setCameraModal(false);
            let filePathArray = filePath
            let fName = fileName
            for(let i = 0; i < res.data.length; i++){
              // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
              let filepath = prefix + '/' + res.data[i].path
              filePathArray.push(filepath)
              // setFilePath(filepath)
              fName.push(res.data[i].filename)
            }
            setFilePath(filePathArray)
            setFileName(fName)
            setLoading(false)
          })
          .catch((err) => {
            setLoading(false)
            console.log(err)
          });
      }
  };

const selectType = (e) => {
  setType(e.target.value)
}
const selectUserType = (e) => {
  setUserType(e.target.value)
}

const changeStatus = (e, ticketIds, statusType="multiple") => {
  setLoading(true)
  // setStatus(e.target.value)
  let requestObj = {
    status: statusType == "single" ? e : e.target.value,
    ticketIds: ticketIds,
  };
  let config = getInstance('POST', `/api/update_ticket_status`, requestObj);
  axios(config)
    // .post(prefix + "/api/create_ticket", requestObj)
    .then((res) => {
      setLoading(false)
      toast.success("Ticket status changed", {
        position: "top-right",
      });
      getTicketList()
      getTicketCount()
      setSelected([])
      setStatusTicktId("")
      setStatusTicktType("")
      setModalStatus(false)
    })
    .catch((err) => {
      let message = "Something went wrong!"
      setLoading(false)
      if(err.response && err.response.data && err.response.data.message){
        message = err.response.data.message
      }
      toast.error(message, {
        position: "top-right",
      });
      console.log(err)
    });
} 

const changeStatusFilter = (e) => {
  setStatusFilter(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const changeUserFilter = (e) => {
  setUserTypeFilter(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const setSearchKey = (e) => {
  setSearchTicket(e.target.value)
  setPageSize(defaultPageSize)
  setCurrentPage(1)
  setSelected([])
}

const openTicketModel = () => {
  setNewEvent(true)
  setFileName([])
}

const rowClasses = (row, rowIndex) => {
    if(row && row.is_new_reply ){
      return 'ticket-highlight';
    } else {
      return ''
    }
};

const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
  if(type == 'pagination'){
    if(sizePerPage != pageSize){
      setPageSize(sizePerPage)
      setCurrentPage(1)
    } else {
      setCurrentPage(page)
    }
    setSelected([])
  } else if(type == 'sort'){
    setSortType(sortOrder)
    setSortKey(sortField)
    setPageSize(defaultPageSize)
    setCurrentPage(1)
    setSelected([])
  }
}

const selectRow = {
  mode: 'checkbox',
  // clickToSelect: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? true : false,
  hideSelectColumn: localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? false : true,
  selected: selected,
  onSelect: (row, isSelect, rowIndex, e) => {
    if (isSelect) {
      setSelected([...selected, row.id])
    } else {
      setSelected(selected.filter(x => x !== row.id))
    }
  },
  onSelectAll: (isSelect, rows, e) => {
    const ids = rows.map(r => r.id);
    if (isSelect) {
      setSelected(ids)
    } else {
      setSelected([])
    }
  }
};
  return (
    <Fragment>
      {/* <PageTitle activeMenu="Table" motherMenu="Bootstrap" /> */}
      {/* <div className="deznav"> */}
      <PerfectScrollbar className="deznav-scroll">
        <div style={{ display: "inline" }}>
          <select
            className="form-control form-border-color"
            style={{
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="filter"
            id="filter"
            defaultValue={statusFilter}
            onChange={(e) => changeStatusFilter(e)}
          >
            <option value="4">All Status</option>
            <option value="0">Open</option>
            <option value="1">Completed</option>
            <option value="2">Pending</option>
            <option value="3">Spam</option>
          </select>
          <React.Fragment>
          {localStorage.getItem("userType") == 1 ||
          localStorage.getItem("userType") == 2 ?       
          <select
            className="form-control form-border-color"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            name="user_filter"
            id="user_filter"
            defaultValue={userTypeFilter}
            onChange={(e) => changeUserFilter(e)}
          >
            <option value="0">All User</option>
            <option value="1">Admin</option>
            <option value="2">Employee</option>
            <option value="3">Customer</option>
            <option value="4">Provider</option>
          </select> : ""}
          </React.Fragment>  

          <input
            type="text"
            name="title"
            style={{
              marginLeft: "5px",
              width: "fit-content",
              display: "inline",
              marginBottom: "1rem",
            }}
            className="form-control form-border-color"
            maxLength={255}
            placeholder="Search Here..."
            value={searchTicket}
            onChange={(e) => setSearchKey(e)}
          />
          <span class="badge badge-sm light badge-primary status-count-span status-open">
            Open : {openCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-pending">
            Pending : {pendingCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-closed">
          Completed : {closedCount}
          </span>
          <span class="badge badge-sm light badge-primary status-count-span status-spam">
          Spam : {spamCount}
          </span>

          <Button
            as="a"
            // className="add-menu-sidebar"
            style={{ float: "right", marginBottom: "1rem" }}
            data-toggle="modal"
            data-target="#addOrderModalside"
            onClick={() => openTicketModel()}
          >
            + New Ticket
          </Button>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Modal
          show={modalStatus}
          // onHide={() => this.setState({ cameraModal: false })}
          className="modal fade"
          id="statusModal"
        >
        <div className="">
            <div className="modal-header">
              <h5 className="modal-title">Update Status - BGTKT{statusTicktId}</h5>
              <Button
                variant=""
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setModalStatus(false)}
              >
                <span>×</span>
              </Button>
            </div>
            <div className="modal-body">
              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // setNewEvent(false);
                }}
              >
                <div>
                  <div className="form-group">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select Type
                      </label>
                      <select
                        className="form-control form-border-color"
                        // style={{ width: "fit-content" }}
                        name="type"
                        id="type"
                        defaultValue={statusTicktType}
                        onChange={(e) => onStatusChange(e)}
                      >
                        <option value="0">Open</option>
                        <option value="1">Completed</option>
                        <option value="2">Pending</option>
                        <option value="3">Spam</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ textAlign: "center" }}>
                    <input
                      disabled={loading}
                      type="submit"
                      value="Update Status"
                      className="btn btn-primary"
                      onClick={() => changeStatus(status, [statusTicktId], "single")}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        <Modal enforceFocus={false} className="modal fade" show={newEvent}>
          <div className="">
            <div className="modal-header">
              <h5 className="modal-title">Add Ticket</h5>
              <Button
                variant=""
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setNewEvent(false)}
              >
                <span>×</span>
              </Button>
            </div>
            <div className="modal-body">
              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // setNewEvent(false);
                }}
              >
                <div>
                  <div className="form-group">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select Type
                      </label>
                      <select
                        className="form-control form-border-color"
                        name="type"
                        id="type"
                        onChange={(e) => selectType(e)}
                      >
                        <option value="0">Tech Support</option>
                        <option value="1">Order Support</option>
                        <option value="2">Order Inquiry</option>
                        <option value="3">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="text-black font-w500">Title</label>
                      <input
                        type="text"
                        name="title"
                        className="form-control form-border-color"
                        maxLength={255}
                        required
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <label className="text-black font-w500">Message</label>
                    {/* <textarea
                      name="message"
                      id="textarea"
                      cols={30}
                      rows={5}
                      maxLength={1500}
                      className="form-control bg-transparent"
                      placeholder="Please enter ticket message"
                      defaultValue={""}
                      required
                      onChange={(e) => setmessage(e.target.value)}
                    /> */}
                    <ReactQuill theme="snow" value={message} onChange={setmessage} />
                  </div>
                  {localStorage.getItem("userType") == 1 ||
                  localStorage.getItem("userType") == 2 ? (
                    <div className="form-group">
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Customer/Provider Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          className="form-control form-border-color"
                          maxLength={255}
                          required
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="text-black font-w500">
                          Select User
                        </label>
                        <select
                          className="form-control form-border-color"
                          name="user-type"
                          id="user-type"
                          onChange={(e) => selectUserType(e)}
                        >
                          <option value="0">Select User</option>
                          <option value="3">Customer</option>
                          <option value="4">Provider</option>
                        </select>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="form-group">
                    <label
                      className="text-black font-w500"
                      style={{ display: "block" }}
                    >
                      Order ID (If Applicable)
                    </label>
                    BGUSA{" "}
                    <input
                      type="number"
                      name="order_id"
                      className="form-control form-border-color"
                      maxLength={11}
                      style={{ display: "initial", width: "70%" }}
                      onChange={(e) =>
                        // alert(e)
                        setOrderId(e.target.value)
                      }
                    />
                  </div>

                  {/* <div className="form-group">
                  <div className="modal-body">
                        <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">Upload</span>
                          </div>
                          <div className="custom-file">
                            <input
                              type="file"
                              name="file"
                              className="custom-file-input"
                              onChange={(e) => handleImageChange(e)}
                            />
                            <label className="custom-file-label">
                              Choose file
                            </label>
                            <label className="custom-file-label" >{fileLabel}</label>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  <div className="form-group">
                    <button
                      // to="/app-profile"
                      disabled={loading}
                      className="btn btn-primary light px-3 "
                      data-toggle="modal"
                      data-target="#cameraModal"
                      type="button"
                      onClick={() => setCameraModal(true)}
                    >
                      <i className="fa fa-camera m-0" />
                      {" Upload File "}
                    </button>
                    {fileName.map(function (name, j) {
                      return (
                        <div>
                          {name}
                          <br />
                        </div>
                      );
                    })}
                    {/* {fileName} */}
                  </div>
                  {/* Modal */}
                  <Modal
                    show={cameraModal}
                    // onHide={() => this.setState({ cameraModal: false })}
                    className="modal fade"
                    id="cameraModal"
                  >
                    <div className="">
                      <div className="modal-header">
                        <h5 className="modal-title">Upload images</h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          onClick={() => setCameraModal(false)}
                        >
                          <span>×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <span className="input-group-text">Upload</span>
                          </div>
                          <div className="custom-file ">
                            <input
                              type="file"
                              name="file"
                              multiple
                              className="custom-file-input"
                              onChange={(e) => onFileChange(e)}
                            />
                            <label className="custom-file-label form-border-color">
                              Choose file
                            </label>
                          </div>
                        </div>
                        <div class="form-group">
                          <Progress max="100" color="success" value={loaded}>
                            {Math.round(loaded, 2)}%
                          </Progress>
                        </div>
                      </div>
                    </div>
                  </Modal>
                  <div className="form-group" style={{ textAlign: "center" }}>
                    <input
                      disabled={loading}
                      type="submit"
                      value="Create Ticket"
                      className="btn btn-primary"
                      onClick={() => createTicket()}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </PerfectScrollbar>
      {/* </div> */}
      <Row>
        <Col lg={12}>
          <Card className="form-border-color">
            <Card.Header style={{borderBottom : "0px", paddingBottom : "0.5rem"}}>
              <Card.Title>Ticket List</Card.Title>
            </Card.Header>
            <div className="ticket-type-count-div">
              {localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? 
              <React.Fragment>
              <span class="badge badge-sm light badge-primary status-count-span rent-count">
                Rent : {rentCount}
              </span>
              <span class="badge badge-sm light badge-primary status-count-span support-count">
                Support : {supportCount}
              </span></React.Fragment> : ""}
              </div>
            <Card.Body style={{paddingBottom : "1.5rem"}}>
              {/* <Table responsive>
                <thead>
                  <tr>
                    <th className="width80">
                      <strong>#</strong>
                    </th>
                    <th>
                      <strong>Title</strong>
                    </th>
                    <th>
                      <strong>TYPE</strong>
                    </th>
                    <th>
                      <strong>Ticket Owner</strong>
                    </th>
                    <th>
                      <strong>Order Id</strong>
                    </th>
                    <th>
                      <strong>Created Date</strong>
                    </th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    {localStorage.getItem("userType") == 1 ||
                    localStorage.getItem("userType") == 2 ? (
                      <th>
                        <strong>Action</strong>
                      </th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {loadingList ? (
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        position: "absolute",
                        marginBottom: "10px",
                      }}
                    >
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden"></span>
                      </Spinner>
                    </div>
                  ) : ticketList.length > 0 ? (
                    ticketList.map(function (item, i) {
                      return (
                        <tr className={item.is_new_reply ? "ticket-highlight" : ""}>
                          <td>
                            <Link to={`/ticket/${item.id}`}>
                              <strong>{"BGTKT" + item.id}</strong>
                            </Link>
                          </td>
                          <td>
                            <Link style={{color : "#111"}}to={`/ticket/${item.id}`}>{item.title}</Link>
                          </td>
                          <td>
                            {item.type == 0
                              ? "Tech Support"
                              : item.type == 1
                              ? "Order Support"
                              : item.type == 2
                              ? "Order Inquiry"
                              : item.type == 3
                              ? "Other"
                              : "-"}
                          </td>
                          <td>
                            {item.user
                              ? item.user.first_name && item.user.last_name
                                ? item.user.first_name +
                                  " " +
                                  item.user.last_name
                                : item.user.first_name
                                ? item.user.first_name
                                : item.user.last_name
                                ? item.user.last_name
                                : "-"
                              : "-"}
                          </td>
                          <td>
                            {item.order_id ? "BGUSA" + item.order_id : "-"}
                          </td>
                          <td>
                            {new Date(item.createdAt).toLocaleString("en-US")}
                          </td>
                          <td>
                            <Badge variant="success light" className={item.status == 0 ?"status-open" : item.status == 1 ? "status-closed" : "status-pending"}>
                              {item.status == 0
                                ? "Open"
                                : item.status == 1
                                ? "Closed"
                                : "Pending"}
                            </Badge>
                          </td>

                          {localStorage.getItem("userType") == 1 ||
                          localStorage.getItem("userType") == 2 ? (
                            <td>
                              <select
                                className="form-control form-border-color"
                                style={{ width: "fit-content" }}
                                name="type"
                                id="type"
                                defaultValue={item.status}
                                onChange={(e) => changeStatus(e, item.id)}
                              >
                                <option value="0">Open</option>
                                <option value="1">Closed</option>
                                <option value="2">Pending</option>
                              </select>
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        position: "absolute",
                        marginBottom: "10px",
                      }}
                    >
                      <span style={{ fontWeight: "700" }}>
                        {"No Data Found."}
                      </span>
                    </div>
                  )}
                </tbody>
              </Table> */}
              <div>{columneDisplayValue}</div>
              {loadingList ? (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>
                </div>
              ) : ticketList.length > 0 ? (
                    <div>
                      <Dropdown style={{display : "inline-block"}} show={show}>
                        <Dropdown.Toggle
                          onClick={() => setShow(!show)}
                          variant="success"
                          id="dropdown-basic"
                        >
                          Show/Hide
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="dropdown-custom">
                          {returnList()}
                        </Dropdown.Menu>
                      </Dropdown>
                      <div style={{display : "inline-block", paddingLeft : "1rem"}}>
                    {(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) && selected.length > 0 ?
                        <select
                      className="form-control form-border-color"
                      style={{
                        height : "auto"
                        // width: "fit-content",
                        // display: "inline",
                        // marginBottom: "1rem",
                      }}
                      name="type"
                      id="type"
                      defaultValue={""}
                      onChange={(e) => changeStatus(e, selected)}
                    >
                      <option value="" disabled>Change Status</option>
                      <option disabled = {statusFilter == 0 ? true : null} value="0">Open</option>
                      <option disabled = {statusFilter == 1 ? true : null} value="1">Completed</option>
                      <option disabled = {statusFilter == 2 ? true : null} value="2">Pending</option>
                      <option disabled = {statusFilter == 3 ? true : null} value="3">Spam</option>
                    </select>
                  :""}
                  </div>
                      <hr />
                      <BootstrapTable
                      remote
                        className="table-responsive"
                        keyField="id"
                        data={ticketData}
                        columns={columns}
                        pagination={ paginationFactory({ page : currentPage, sizePerPage : pageSize, totalSize:totalCount, paginationSize : 3, sizePerPageList : sizePerPageList }) }
                        rowClasses={ rowClasses }
                        onTableChange={ handleTableChange }
                        selectRow={ selectRow }
                      />
                    </div>
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ fontWeight: "700" }}>{"🎉 No Tickets."}</span>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default TicketList;
